// Category Carousel — tiles that link straight to their collection.
// Drag/scroll/keyboard navigation of the rail is preserved. Navigation
// is triggered manually on a clean tap (no drag), because pointer
// capture on the viewport prevents the anchor's native click from
// firing reliably.

function initTileCarousel(viewport, rail, onTap) {
  function getItems() {
    return Array.prototype.slice.call(rail.querySelectorAll('.cc-item'));
  }
  if (getItems().length === 0) return null;

  var GAP = 8;
  var FALLOFF_INDEX = 2;
  var staticMode = false;

  var fillRatioSetting = parseFloat(viewport.dataset.fillRatio);
  var FILL_RATIO = (isNaN(fillRatioSetting) ? 65 : fillRatioSetting) / 100;

  var LARGE, SMALL, STEP_PX, MOMENTUM_PX, TILE_HEIGHT;

  function recomputeSizes() {
    var items = getItems();
    var w = viewport.clientWidth;
    if (w >= 900) {
      LARGE = 320; SMALL = 90; TILE_HEIGHT = 320;
    } else if (w >= 600) {
      LARGE = 260; SMALL = 72; TILE_HEIGHT = 260;
    } else {
      LARGE = 220; SMALL = 56; TILE_HEIGHT = 220;
    }
    STEP_PX = LARGE * 0.86;
    MOMENTUM_PX = STEP_PX * 0.74;

    var allLargeWidth = items.length * LARGE + (items.length - 1) * GAP;
    staticMode = allLargeWidth <= w;

    if (staticMode) {
      var stretched = ((w - GAP * (items.length - 1)) / items.length) * FILL_RATIO;
      LARGE = Math.min(stretched, 480);
      TILE_HEIGHT = LARGE;
    }

    viewport.style.cursor = staticMode ? 'default' : 'grab';
    rail.classList.toggle('cc-fit', staticMode);

    var CAROUSEL_VPADDING = 22;
    viewport.style.height = (TILE_HEIGHT + CAROUSEL_VPADDING) + 'px';
    items.forEach(function (item) {
      item.style.height = TILE_HEIGHT + 'px';
      var inner = item.querySelector('.cc-inner');
      if (inner) { inner.style.width = LARGE + 'px'; }
    });
  }

  function smoothstep(t) { return t * t * (3 - 2 * t); }

  function applyLayout(fp) {
    var items = getItems();

    if (staticMode) {
      items.forEach(function (item) {
        item.style.width = LARGE + 'px';
        var inner = item.querySelector('.cc-inner');
        inner.style.left = '0';
        inner.style.right = 'auto';
        var label = item.querySelector('.cc-label');
        if (label) label.style.opacity = 1;
      });
      rail.style.transform = 'translateX(0px)';
      return;
    }

    var widths = items.map(function (item, i) {
      var distance = i - fp;
      var t = Math.min(Math.abs(distance) / FALLOFF_INDEX, 1);
      var eased = smoothstep(t);
      return LARGE - (LARGE - SMALL) * eased;
    });

    items.forEach(function (item, i) {
      item.style.width = widths[i] + 'px';

      var distance = i - fp;
      var inner = item.querySelector('.cc-inner');
      if (distance < 0) {
        inner.style.left = 'auto';
        inner.style.right = '0';
      } else {
        inner.style.left = '0';
        inner.style.right = 'auto';
      }

      var t = Math.min(Math.abs(distance) / FALLOFF_INDEX, 1);
      var eased = smoothstep(t);
      var focusAmount = 1 - eased;
      var label = item.querySelector('.cc-label');
      if (label) label.style.opacity = Math.max(focusAmount, 0.15);
    });

    var floorIdx = Math.max(0, Math.floor(fp));
    var frac = fp - Math.floor(fp);
    var shift = 0;
    for (var i = 0; i < floorIdx; i++) { shift += widths[i] + GAP; }
    if (floorIdx < widths.length) { shift += frac * (widths[floorIdx] + GAP); }

    var totalContentWidth = widths.reduce(function (a, b) { return a + b; }, 0) + GAP * (widths.length - 1);
    var availableWidth = viewport.clientWidth;
    var maxShift = Math.max(0, totalContentWidth - availableWidth);
    shift = Math.max(0, Math.min(shift, maxShift));

    rail.style.transform = 'translateX(' + (-shift) + 'px)';
  }

  var focusedIndex = 0;
  var settleClassTimer = null;

  function settleTo(target) {
    var items = getItems();
    target = Math.max(0, Math.min(items.length - 1, target));
    viewport.classList.add('settling');
    applyLayout(target);
    focusedIndex = target;
    clearTimeout(settleClassTimer);
    settleClassTimer = setTimeout(function () { viewport.classList.remove('settling'); }, 340);
    return target;
  }

  var isDragging = false;
  var directionLocked = null;
  var dragStartX = 0, dragStartY = 0;
  var lastMoveX = 0, lastMoveT = 0, velocity = 0;
  var liveFp = 0;
  var pointerDownItem = null;

  viewport.addEventListener('pointerdown', function (e) {
    isDragging = true;
    directionLocked = null;
    dragStartX = e.clientX;
    dragStartY = e.clientY;
    lastMoveX = e.clientX;
    lastMoveT = performance.now();
    velocity = 0;
    liveFp = focusedIndex;
    pointerDownItem = e.target.closest ? e.target.closest('.cc-item') : null;
    viewport.classList.remove('settling');
    if (viewport.setPointerCapture) {
      try { viewport.setPointerCapture(e.pointerId); } catch (err) {}
    }
  });

  viewport.addEventListener('pointermove', function (e) {
    if (!isDragging) return;
    var dx = e.clientX - dragStartX;
    var dy = e.clientY - dragStartY;

    if (directionLocked === null) {
      if (Math.abs(dx) > 6 || Math.abs(dy) > 6) {
        directionLocked = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }
    }
    if (directionLocked === 'y') {
      isDragging = false;
      return;
    }
    if (directionLocked === 'x') {
      e.preventDefault();
    }

    var now = performance.now();
    var dt = now - lastMoveT;
    if (dt > 0) { velocity = (e.clientX - lastMoveX) / dt; }
    lastMoveX = e.clientX;
    lastMoveT = now;

    var items = getItems();
    var offsetUnits = -dx / STEP_PX;
    liveFp = Math.max(0, Math.min(items.length - 1, focusedIndex + offsetUnits));
    applyLayout(liveFp);
  });

  function endDrag() {
    if (!isDragging) return;
    isDragging = false;

    if (directionLocked === null) {
      // A clean tap, no drag: navigate manually, since pointer capture
      // on the viewport prevents the anchor's native click/navigation
      // from firing reliably.
      if (pointerDownItem && pointerDownItem.href) {
        window.location.href = pointerDownItem.href;
      }
      applyLayout(focusedIndex);
      return;
    }

    if (directionLocked !== 'x') {
      applyLayout(focusedIndex);
      return;
    }

    var momentumUnits = (-velocity * MOMENTUM_PX) / STEP_PX;
    var target = Math.round(liveFp + momentumUnits);
    settleTo(target);
  }

  viewport.addEventListener('pointerup', endDrag);
  viewport.addEventListener('pointercancel', endDrag);
  viewport.addEventListener('pointerleave', function () { if (isDragging) endDrag(); });

  // Navigation is handled manually above (see endDrag). Always block the
  // native click so a drag that releases over a tile can't double-fire
  // or cause an unwanted browser default.
  rail.addEventListener('click', function (e) {
    e.preventDefault();
  }, true);

  var wheelStartFocus = null;
  var wheelAccumPx = 0;
  var wheelTimer = null;

  viewport.addEventListener('wheel', function (e) {
    if (staticMode) return;
    e.preventDefault();
    var delta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;

    if (wheelStartFocus === null) { wheelStartFocus = focusedIndex; wheelAccumPx = 0; }
    wheelAccumPx += delta;

    var items = getItems();
    var offsetUnits = wheelAccumPx / STEP_PX;
    liveFp = Math.max(0, Math.min(items.length - 1, wheelStartFocus + offsetUnits));
    applyLayout(liveFp);

    clearTimeout(wheelTimer);
    wheelTimer = setTimeout(function () {
      settleTo(Math.round(liveFp));
      wheelStartFocus = null;
      wheelAccumPx = 0;
    }, 150);
  }, { passive: false });

  viewport.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight' && !staticMode) {
      e.preventDefault();
      var t1 = settleTo(focusedIndex + 1);
      getItems()[t1].focus();
    } else if (e.key === 'ArrowLeft' && !staticMode) {
      e.preventDefault();
      var t2 = settleTo(focusedIndex - 1);
      getItems()[t2].focus();
    } else if (e.key === 'Enter' || e.key === ' ') {
      var focusedEl = document.activeElement;
      if (focusedEl && rail.contains(focusedEl) && focusedEl.href) {
        e.preventDefault();
        window.location.href = focusedEl.href;
      }
    }
  });

  window.addEventListener('resize', function () {
    recomputeSizes();
    applyLayout(focusedIndex);
  });

  recomputeSizes();
  applyLayout(0);

  return { recomputeSizes: recomputeSizes, applyLayout: function () { applyLayout(0); } };
}

window.initCategoryCarousel = function (sectionId) {
  var viewport = document.getElementById('cc-viewport-' + sectionId);
  var rail = document.getElementById('cc-rail-' + sectionId);
  if (!viewport || !rail) return;

  if (rail.dataset.ccInitialized === 'true') return;
  rail.dataset.ccInitialized = 'true';

  initTileCarousel(viewport, rail);
};